import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Intercom, { IReactIntercomProps } from 'react-intercom';

import Login from '../containers/Login';
import LoginSso from '../containers/LoginSso';
import Maintenance from '../containers/Maintenance';
import PasswordReset from '../containers/PasswordReset';
import Setup from '../containers/Setup';
import { InitializationState } from '../types';
import * as styles from './App.module.scss';
import { getConfig } from '../utils';

/**
 * Renders the appropriate app content based on the current route, whether the app has been
 * initialized, and the current authorization data.
 */
export default function App(props: AppProps) {
  const { appState } = props;

  return (
    <div className={styles.root}>
      {appState === InitializationState.loading ? (
        <div className={styles.loading} />
      ) : appState === InitializationState.unauthorized ? (
        <Switch>
          <Route path="/login-sso" component={LoginSso} />
          <Route path="/maintenance" component={Maintenance} />
          <Route path="/reset" component={PasswordReset} />
          <Route path="/setup" component={Setup} />
          <Route component={Login} />
        </Switch>
      ) : (
        <Switch>
          <Route path="/maintenance" component={Maintenance} />
          <Route path="/setup" component={Setup} />
          <Route component={Login} />
        </Switch>
      )}
    </div>
  );
}

export interface AppProps {
  appState: InitializationState;
}
